/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

// 'use strict';

// ;( function ( document, window, index )
// {
// 	var inputs = document.querySelectorAll( '.field-input-file' );
// 	Array.prototype.forEach.call( inputs, function( input )
// 	{
// 		var label	 = input.nextElementSibling,
// 			labelVal = label.innerHTML;

// 		input.addEventListener( 'change', function( e )
// 		{
// 			var fileName = '';
// 			if( this.files && this.files.length > 1 )
// 				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
// 			else
// 				fileName = e.target.value.split( '\\' ).pop();

// 			if( fileName )
// 				label.querySelector( 'span' ).innerHTML = fileName;
// 			else
// 				label.innerHTML = labelVal;
// 		});

// 		// Firefox bug fix
// 		input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
// 		input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
// 	});
// }( document, window, 0 ));

export default function () {
	$(".field-input-file").each(function () {
		var $input = $(this),
			$label = $input.next("label"),
			labelVal = $label.html();

		$input.on("change", function (e) {
			var fileName = "";

			if (this.files && this.files.length > 1)
				fileName = (
					this.getAttribute("data-multiple-caption") || ""
				).replace("{count}", this.files.length);
			else if (e.target.value)
				fileName = e.target.value.split("\\").pop();

			if (fileName) $label.find("span").html(fileName);
			else $label.html(labelVal);
		});

		// Firefox bug fix
		$input
			.on("focus", function () {
				$input.addClass("has-focus");
			})
			.on("blur", function () {
				$input.removeClass("has-focus");
			});
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/forms/input-file.js